import { isNullOrUndefined } from '@coveo/bueno';
import { createSelector } from '@reduxjs/toolkit';
import { totalEntriesRecommendationSelector } from '../pagination/pagination-selectors.js';
export const numberOfRecommendationsSelector = (state, slotId) => state.recommendations
    ? state.recommendations[slotId]?.products.length || 0
    : 0;
export const moreRecommendationsAvailableSelector = createSelector((state, slotId) => ({
    total: totalEntriesRecommendationSelector(state, slotId),
    current: numberOfRecommendationsSelector(state, slotId),
}), ({ current, total }) => current < total);
export const isLoadingSelector = (state, slotId) => {
    const isLoading = state.recommendations
        ? state.recommendations[slotId]?.isLoading
        : false;
    return isNullOrUndefined(isLoading) ? false : isLoading;
};
